import { Routes } from '@angular/router';
import { VoucherComponent } from '@features/voucher/voucher.component';
import { ErrorComponent } from '@features/error/error.component';
import { CheckoutFormNequiComponent } from '@features/checkout-form-nequi/checkout-form-nequi.component';
import { CheckoutClinngVoucherComponent } from '@features/checkout-clinng-voucher/checkout-clinng-voucher.component';
import { CheckoutFormMoviiComponent } from '@features/checkout-form-movii/checkout-form-movii.component';
import { CheckoutStatusMoviiComponent } from '@features/checkout-status-movii/checkout-status-movii.component';
import { CheckoutTransfiyaComponent } from '@features/checkout-transfiya/checkout-transfiya.component';
import { CheckoutFormBreBComponent } from '@features/checkout-form-bre-b/checkout-form-bre-b.component';
import { DownloadVoucherComponent } from '@features/daviplata-voucher/download-voucher/download-voucher.component';
import { ErrorPageComponent } from '@features/error-page/error-page.component';
import { DaviplataVoucherComponent } from '@features/daviplata-voucher/daviplata-voucher.component';

export const routes: Routes = [
  {
    path: 'daviplata/form/:transactionId',
    component: VoucherComponent,
  },
  {
    path: 'nequi/form/:transactionId',
    component: CheckoutFormNequiComponent,
  },
  {
    path: 'movii/form/:verification',
    component: CheckoutFormMoviiComponent,
  },
  {
    path: 'movii/status/:transactionId',
    component: CheckoutStatusMoviiComponent,
  },
  {
    path: 'clinng/voucher/:transactionId',
    component: CheckoutClinngVoucherComponent,
  },
  {
    path: 'transfiya/bt/:transactionId',
    component: CheckoutTransfiyaComponent,
  },
  {
    path: 'breb/voucher/:transactionId',
    component: CheckoutFormBreBComponent,
  },
  {
    path: 'error/:id',
    component: ErrorComponent,
  },
  {
    path: 'error-status/:id',
    component: ErrorComponent,
  },

  {
    path: 'daviplata/download/:transactionId',
    component: DownloadVoucherComponent,
  },
  {
    path: 'niubiz/wallet/:transactionId',
    component: ErrorPageComponent,
  },
  {
    path: 'coinag/bt/:transactionId',
    component: ErrorPageComponent,
  },
  {
    path: 'payphone/:method/:transactionId',
    component: ErrorPageComponent,
  },

  {
    path: 'error',
    component: ErrorPageComponent,
  },
  {
    path: 'error/daviplata',
    component: ErrorPageComponent,
  },

  {
    path: 'legacy/daviplata/form/:transactionId',
    component: DaviplataVoucherComponent,
  },

  { path: '', redirectTo: 'daviplata/form/0', pathMatch: 'full' },

  {
    path: '**',
    component: ErrorComponent,
  },
];
